module.exports = __webpack_public_path__ + "static/media/neoplasms-icon.3e65f319.svg";